import { render, staticRenderFns } from "./TheUserList.vue?vue&type=template&id=0c8c967f&scoped=true&"
import script from "./TheUserList.vue?vue&type=script&lang=js&"
export * from "./TheUserList.vue?vue&type=script&lang=js&"
import style0 from "./TheUserList.vue?vue&type=style&index=0&id=0c8c967f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c967f",
  null
  
)

export default component.exports